import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white relative overflow-hidden">
      {/* Wave decoration */}
      <div className="wave-background">
        <div className="wave"></div>
        <div className="wave"></div>
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Vessel Types */}
          <div>
            <h3 className="text-lg font-bold text-ocean-400 mb-4 flex items-center">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
              </svg>
              Vessels Types
            </h3>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center">
                <span className="w-2 h-2 bg-ocean-500 rounded-full mr-3"></span>
                Accommodation Boats
              </li>
              <li className="flex items-center">
                <span className="w-2 h-2 bg-ocean-500 rounded-full mr-3"></span>
                Crew Boats
              </li>
              <li className="flex items-center">
                <span className="w-2 h-2 bg-ocean-500 rounded-full mr-3"></span>
                Survey Boats
              </li>
              <li className="flex items-center">
                <span className="w-2 h-2 bg-ocean-500 rounded-full mr-3"></span>
                AHTS
              </li>
              <li className="flex items-center">
                <span className="w-2 h-2 bg-ocean-500 rounded-full mr-3"></span>
                PSVs
              </li>
            </ul>
          </div>

          {/* Egypt Contacts */}
          <div>
            <h3 className="text-lg font-bold text-ocean-400 mb-4 flex items-center">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
              </svg>
              Egypt Contacts
            </h3>
            <div className="text-gray-300 space-y-4">
              {/* Head Office - Cairo */}
              <div className="bg-gray-800/50 rounded-lg p-3">
                <p className="text-sm font-semibold text-ocean-400 mb-2">Head Office - Cairo</p>
                <p className="text-xs">Cairo, Egypt</p>
                <p className="text-xs mt-2">
                  <span className="text-ocean-400">Email:</span> operation@petro-marine.net
                </p>
              </div>
              
              {/* Sub Office - Alexandria */}
              <div className="bg-gray-800/30 rounded-lg p-3">
                <p className="text-sm font-semibold text-gray-400 mb-2">Sub Office - Alexandria</p>
                <p className="text-xs">Albert Ajawal St., Southy Boushra Towers, Building C,</p>
                <p className="text-xs">Suite 1203 Semouha, Alexandria - Egypt</p>
                <p className="text-xs mt-2">
                  <span className="text-ocean-400">Tel:</span> +20 3 - 42 96 238, +20 122 772 5599
                </p>
                <p className="text-xs">
                  <span className="text-ocean-400">Fax:</span> +20 3 - 42 96 238
                </p>
              </div>
            </div>
          </div>


        </div>

        {/* Bottom section */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-4 mb-4 md:mb-0">
              <img
                src="/logo.jpg"
                alt="Petromarine Logo"
                className="h-10 w-auto"
              />
              <div>
                <p className="text-ocean-400 font-bold">PetroMarine</p>
                <p className="text-xs text-gray-400">Offshore Projects Support Co.</p>
              </div>
            </div>
            <div className="text-center md:text-right">
              <p className="text-sm text-gray-400">
                © {new Date().getFullYear()} PetroMarine Offshore Projects Support Co. All rights reserved.
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Quality services to the offshore industry in Egypt
              </p>
              <p className="text-xs text-gray-500 mt-2">
                Powered by{' '}
                <a 
                  href="https://crvdeg.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-ocean-400 hover:text-ocean-300 transition-colors duration-200 underline decoration-dotted underline-offset-2"
                >
                  CRVD
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;